import { render, staticRenderFns } from "./treasureList.vue?vue&type=template&id=31a79586&scoped=true&"
import script from "./treasureList.vue?vue&type=script&lang=js&"
export * from "./treasureList.vue?vue&type=script&lang=js&"
import style0 from "./treasureList.vue?vue&type=style&index=0&id=31a79586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a79586",
  null
  
)

export default component.exports